import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';

import translate from '../../utils/translate';

import Carousel, { DIRECTION_VERTICAL } from '../../components/carousel/carousel';
import defaultDecoratorPkg from '../../components/carousel/defaultDecorator';

import step1 from './step1.png';
import step2 from './step2.png';
import step3 from './step3.png';
import step4 from './step4.png';
import step5 from './step5.png';
import step6 from './step6.png';

export default class Onboarding extends Component {
	static propTypes = {
		name: PropTypes.string,
	};

	static defaultProps = {
		name: 'onboard',
	};

	constructor(props) {
		super();

		this.state = {
			show: !(localStorage[props.name] === 'seen'),
		};
	}

	componentWillUnmount() {
		document.body.classList.remove('body--context-menu');
	}

	render() {
		let onboardClass = 'onboarding';
		if (this.state.show) {
			onboardClass += ' onboarding--active';
			document.body.classList.add('body--context-menu');
		} else {
			document.body.classList.remove('body--context-menu');
		}

		let decorators = [defaultDecoratorPkg, PaginationDecoratorPkg];

		return (
			<div className={onboardClass} onClick={(e) => { this.toggle(this.state.show); }}>
				<div className='onboarding__content span14' onClick={(e) => { e.stopPropagation(); }}>
					<a className='onboarding__content__close' onClick={(e) => {
						e.preventDefault();
						this.toggle(this.state.show);
					}}></a>

					<div className='onboarding__content__controls'>

					</div>

					<Carousel autoplay={false} sliderClass='span100p' sliderListClass='span100p' decorators={decorators} decoratorData={{ toggle: (val) => this.toggle(val)}} direction={DIRECTION_VERTICAL}>

						<OnboardingItem browser={this.props.browser} img={step1} title={translate('livejudging/step1Title')} text={translate('livejudging/step1Text')} />

						<OnboardingItem browser={this.props.browser} img={step2} title={translate('livejudging/step2Title')} text={translate('livejudging/step2Text')} />

						<OnboardingItem browser={this.props.browser} img={step3} title={translate('livejudging/step3Title')} text={translate('livejudging/step3Text')} />

						<OnboardingItem browser={this.props.browser} img={step4} title={translate('livejudging/step4Title')} text={translate('livejudging/step4Text')} />

						<OnboardingItem browser={this.props.browser} img={step5} title={translate('livejudging/step5Title')} text={translate('livejudging/step5Text')} />

						<OnboardingItem browser={this.props.browser} img={step6} title={translate('livejudging/step6Title')} text={translate('livejudging/step6Text')} />

						<div className='onboarding__content__wrapper'>
							<div className='onboarding__content__col'>
								<div className='onboarding__content__col__cat'>FWA Live Judging</div>
								<div className='onboarding__content__twocol'>
									<div className='onboarding__content__twocol__item'>
										<h3 className='onboarding__content__twocol__title'>{translate('livejudging/step7Title1')}</h3>
										<p className='onboarding__content__twocol__text' dangerouslySetInnerHTML={{ __html: translate('livejudging/step7Text1') }}></p>
									</div>

									<div className='onboarding__content__twocol__item'>
										<h3 className='onboarding__content__twocol__title'>{translate('livejudging/step7Title2')}</h3>
										<p className='onboarding__content__twocol__text' dangerouslySetInnerHTML={{ __html: translate('livejudging/step7Text2') }}></p>
									</div>

									<div className='onboarding__content__twocol__item'>
										<h3 className='onboarding__content__twocol__title'>{translate('livejudging/step7Title3')}</h3>
										<p className='onboarding__content__twocol__text' dangerouslySetInnerHTML={{ __html: translate('livejudging/step7Text3') }}></p>
									</div>
								</div>

							</div>
						</div>

					</Carousel>
				</div>
			</div>
		);
	}

	toggle(val = true) {
		val = val ? 'seen' : 0;
		try {
			localStorage.setItem(this.props.name, val);
		} catch (e) {
			console.log(e);
		} finally {
			this.setState({
				...this.state,
				show: !(val === 'seen'),
			});
		}
	}
}

class OnboardingItem extends Component {
	render() {
		let retina = 1;
		if (this.props.browser && this.props.browser.window.width < 720) {
			retina = 2;
		}

		let width = (this.props.img.width / retina);
		let height = (this.props.img.height / retina);

		return (
			<div className='onboarding__content__wrapper'>
				<div className='onboarding__content__col'>
					<div className='onboarding__content__col__cat'>FWA Live Judging</div>
					<h3 className='onboarding__content__col__title'>{this.props.title}</h3>
					<p className='onboarding__content__col__text' dangerouslySetInnerHTML={{__html: this.props.text}}></p>
				</div>
				<div className='onboarding__content__col onboarding__content__col--img'>
					<img {...this.props.img} width={width} height={height} />
				</div>
			</div>
		);
	}
}

class PaginationDecorator extends Component {
	static propTypes = {
		nextSlide: PropTypes.func.isRequired,
		previousSlide: PropTypes.func.isRequired,
		goToSlide: PropTypes.func.isRequired,
		slideCount: PropTypes.number.isRequired,
		currentSlide: PropTypes.number.isRequired,
		decoratorData: PropTypes.object,
	};

	static defaultProps = {};

	render() {
		let prevClass = 'onboarding__pagination__prev';
		let nextClass = 'onboarding__pagination__next';

		if (this.props.currentSlide > 0) {
			prevClass += ' onboarding__pagination__prev--active';
		}

		if (this.props.currentSlide < this.props.slideCount - 1) {
			nextClass += ' onboarding__pagination__next--active';
		}

		return (
			<div className='onboarding__pagination'>
				<a href='' className={prevClass} onClick={(e) => { e.preventDefault(); this.props.previousSlide(); }}>
					<div className='onboarding__pagination__arrow onboarding__pagination__arrow--up'></div>
				</a>
				<a
					href=''
					className={nextClass}
					onClick={(e) => {
						e.preventDefault();
						// console.log(`${this.props.currentSlide} < ${this.props.slideCount - 1}`);
						if (this.props.currentSlide < (this.props.slideCount - 1)) {
							this.props.nextSlide();
						} else {
							if (this.props.decoratorData && this.props.decoratorData.toggle && typeof this.props.decoratorData.toggle === 'function') {
								this.props.decoratorData.toggle(true);
							}
						}
					}}
				>
					<div className='onboarding__pagination__arrow onboarding__pagination__arrow--down'></div>
				</a>
			</div>
		);
	}
}

let PaginationDecoratorPkg = {
	component: PaginationDecorator,
	style: {},
};



/** WEBPACK FOOTER **
 ** ./frontend/containers/livejudging/onboarding.js
 **/